import { render } from "./ServiceBadge.vue?vue&type=template&id=de10be38"
import script from "./ServiceBadge.vue?vue&type=script&lang=js"
export * from "./ServiceBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__